import React from 'react';
import Snackbar from '../Snackbar/Snackbar';
import useRoomState from '../../hooks/useRoomState/useRoomState';

export default function ReconnectingNotification() {
  const roomState = useRoomState();

  const doctorReconnectingMessage = localStorage.getItem('doctorreconnectingState') ?? 'Reconnecting to room...';

  return (
    <Snackbar
      variant="error"
      headline=""
      message={roomState === 'reconnecting' ? doctorReconnectingMessage : ''}
      open={roomState === 'reconnecting'}
    />
  );
}
